import service from "./axios";

export default {
     //发送短信
     sendNote(query){
        return service({
            url: '/api/third/danmi/sendSms',
            method: 'post',
            params: query
        })
    },
      //统计
      addVideoConver(query){
        return service({
            url: '/api/chat/videos/add',
            method: 'post',
            params: query
        })
    },
     //忙线后将token清空 允许其他人打给客服
     removeEngagedLineToken(query){
        return service({
            url: '/api/chat/visitor/expireVideoToken',
            method: 'post',
            params: query
        })
    },
     //判断忙不忙线中
     engagedLine(query){
        return service({
            url: '/api/chat/visitor/adminVideoStatus',
            method: 'post',
            params: query
        })
    },
    //通知音视频通话
    informVideo(query){
        return service({
            url: '/api/chat/visitor/userVideoInvitation',
            method: 'post',
            params: query
        })
    },
    //获取用户token
    getToken(query){
        return service({
            url: '/api/chat/visitor/getVideoToken',
            method: 'post',
            params: query
        })
    },
    // 获取渠道配置
    getChatChannelInfo(query) {
        return service({
            url: '/api/chat/visitor/channelInfo',
            method: 'post',
            params: query
        })
    },
    // 初始化数据
    setChatInit(query) {
        return service({
            url: '/api/chat/visitor/init',
            method: 'post',
            params: query
        })
    },
    //获取离线消息
    getOfflineMsg(query) {
        return service({
            url: '/api/chat/visitor/getOfflineMsg',
            method: 'post',
            params: query
        })
    },
    getLeaveMsg(query) {
        return service({
            url: '/api/chat/visitor/getLeaveMsg',
            method: 'post',
            params: query
        })
    },
    // 转人工
    transferConnect(query) {
        return service({
            url: '/api/chat/visitor/connect',
            method: 'post',
            params: query
        })
    },
    //轮询消息
    setChatEventMsg(query) {
        return service({
            url: '/api/chat/visitor/getEventMsg',
            method: 'post',
            params: query
        })
    },
    //提交表单
  submitUserForm(query) {
        return service({
            url: '/api/chat/visitor/submitUserForm',
            method: 'post',
            params: query
        })
    },
    //获取历史记录
    getChatHistoryMsg(query) {
        return service({
            url: '/api/chat/visitor/getHistoryMsg',
            method: 'post',
            params: query
        })
    },
    //获取会话消息
    getChatMsg(query) {
        return service({
            url: '/api/chat/visitor/getSessionMsg',
            method: 'post',
            params: query
        })
    },
    //结束会话
    async closeChatVisitor(query) {
        return service({
          url: '/api/chat/visitor/out',
          method: 'post',
          params: query
        });
    },
    // 机器人消息
    sendRobotMsg(query) {
        return service({
            url: '/api/chat/visitor/robotAsk',
            method: 'post',
            params: query
        })
    },
    // 发送客服消息
    sendCustomMsg(query) {
        return service({
            url: '/api/chat/visitor/sendMsg',
            method: 'post',
            params: query
        })
    },
    // 满意度评价
    sendEvaluate(query) {
        return service({
            url: '/api/chat/visitor/evaluate',
            method: 'post',
            params: query
        })
    },
    //是否评价过
    isEvaluate(query) {
        return service({
            url: '/api/chat/visitor/isEvaluate',
            method: 'post',
            params: query
        })
    },
    uploadFileBase64(query) {
        return service({
            url: '/api/chat/visitor/uploadBase64',
            method: 'post',
            params: query,
        })
    },
    // 正在输入
    userTyping(query) {
        return service({
            url: '/api/chat/visitor/typing',
            method: 'post',
            params: query
        })
    },
    // 上传文件
    uploadFile(query) {
        return service({
            url: '/api/chat/visitor/upload',
            method: 'post',
            // type: 'file',
            params: query,
            transformRequest: [function (query) {
                const formData = new FormData();
                formData.append('file', query.file)
                formData.append('userId', query.userId)
                return formData
            }]
        })
    },
    // 机器人建议
    robotTips(query) {
        return service({
            url: '/api/chat/visitor/robotTips',
            method: 'post',
            params: query
        })

    },
    // 获取渠道技能组
    getChannelGroup(query) {
        return service({
            url: '/api/chat/visitor/getChannelGroup',
            method: 'post',
            params: query
        })

    },
    // 获取模板详情
    getMsgTemplateDetail(query) {
        return service({
            url: '/api/basic/msgTemplate/getMsgTemplate',
            method: 'post',
            params: query
        })

    },
    // 敏感词过滤
    msgSensitive(query) {
        return service({
            url: '/api/chat/visitor/checkSensitive',
            method: 'post',
            params: query
        })
    },
    // 获取评价信息
    msgEvaluate(query) {
        return service({
            url: '/api/chat/visitor/getEvaluateInfo',
            method: 'post',
            params: query
        })
    },
    //提交留言
    messageSub(query) {
        return service({
            url: '/api/chat/visitor/leaveMsg',
            method: 'post',
            params: query
        })
    },
    //离开页面
    leavePage(query) {
        return service({
            url: '/api/chat/visitor/beforeUnload',
            method: 'post',
            params: query
        })
    },
    getRobotDoc(query) {
        return service({
            url: '/api/chat/visitor/getRobotDoc',
            method: 'post',
            params: query
        })
    },
    getOrderInfo(query) {
        return service({
            url: '/api/wo/client/info',
            method: 'post',
            params: query
        })
    },
    addReplay(query) {
        return service({
            url: '/api/wo/client/addWoHandleInfo',
            method: 'post',
            params: query
        })
    },
    resetUser(query) {
        return service({
            url: '/api/chat/visitor/changeUser',
            method: 'post',
            params: query
        })
    },
    readMsg(query) {
        return service({
            url: '/api/chat/visitor/msgComplete',
            method: 'post',
            params: query
        })
    },
    
    getTemplateFiledInfoByTypeId(query) {
        return service({
            url: '/api/open/wo/getTemplateFiledInfoByTypeId',
            // url: '/api/open/wo/getTemplateFiledInfoByTemplateId',
            method: 'post',
            params: query
        })
    },
    queryWoByCustom(query) {
        return service({
            url: '/api/open/wo/queryWoByCustom',
            method: 'post',
            params: query
        })
    },
    addWo(query) {
        return service({
            url: '/api/open/wo/addWo',
            method: 'post',
            params: query
        })
    },
    upload(query) {
        return service({
            url: '/api/wo/client/upload',
            method: 'post',
            params: query
        })
    },
    woinfo(query) {
        return service({
            url: '/api/open/wo/queryWoById',
            method: 'post',
            params: query
        })
    },
    addWoHandleInfo(query) {
        return service({
            url: '/api/open/wo/addWoHandleInfo',
            method: 'post',
            params: query
        })
    },
    visitorCommentDoc(query) {
        return service({
            url: '/api/chat/visitor/commentDoc',
            method: 'post',
            params: query
        })
    },
    
    getUser(query) {
        return service({
            url: '/api/chat/visitor/getUser',
            method: 'post',
            params: query
        })
    },

    updateUserInfo(query) {
        return service({
            url: '/api/chat/visitor/updateUserInfo',
            method: 'post',
            params: query
        })
    },

    
    leaveMsg(query) {
        return service({
            url: '/api/chat/visitor/leaveMsg',
            method: 'post',
            params: query
        })
    },

    
    sysMsg(query) {
        return service({
            url: '/api/chat/visitor/sysMsg',
            method: 'post',
            params: query
        })
    },

    isWork(query) {
    return service({
        url: '/api/chat/visitor/isWork',
        method: 'post',
        params: query
    })

},
}



// WEBPACK FOOTER //
// ./src/api/request.js